let PopComponent = {};

PopComponent["AddSkillPop"] = require("./Skill/PopUp/AddSkillPop").default;
PopComponent["AlertPop"] = require("./Skill/PopUp/AlertPop").default;
PopComponent["EditSkillPop"] = require("./Skill/PopUp/EditSkillPop").default;
PopComponent["CoursesPop"] = require("./Skill/PopUp/CoursesPop").default;
PopComponent["AddDegreePop"] = require("./Degree/PopUp/AddDegreePop").default;
PopComponent["AlertPop"] = require("./Degree/PopUp/AlertPop").default;
PopComponent["EditDegreePop"] = require("./Degree/PopUp/EditDegreePop").default;
PopComponent["UserInfo"] = require("./Users/PopUp/UserInfo").default;
PopComponent["ResetPasswordPop"] =
  require("./Users/PopUp/ResetPassword").default;
PopComponent["SearchPop"] = require("./Users/PopUp/SearchPop").default;
PopComponent["ApplicationSearchPop"] = require("./Users/PopUp/ApplicationSearchPop").default
PopComponent["SearchPop"] =
  require("./Add_Admin-constributor/PopComponent/SearchPop").default;
PopComponent["UpgradePop"] = require("./Users/PopUp/UpgradePop").default;
PopComponent["AddUser"] = require("./Users/PopUp/AddUser").default;
PopComponent["AddSkillUPUser"] = require("./Users/PopUp/AddSkillUPUser").default;
PopComponent["UserPop"] = require("./Course/PopContent/UserPop").default;
PopComponent["GroupPop"] = require("./Course/PopContent/GroupsPop").default;
PopComponent["PostPop"] = require("./Course/PopContent/PostPop").default;
PopComponent["prePostPop"] = require("./Course/PopContent/prePostPop").default;
PopComponent["certPostPop"] = require("./Course/PopContent/certPostPop").default;
PopComponent["DeletePostPop"] =
  require("./Course/PopContent/AlertPostPop").default;
PopComponent["AddPostPop"] = require("./Course/PopContent/AddPostPop").default;
PopComponent["AlertPost"] = require("./Course/PopContent/AlertPost").default;
PopComponent["CourseSkillsPop"] =
  require("./Course/PopContent/SkillsPop").default;
PopComponent["CourseSearchPop"] =
  require("./Course/PopContent/SearchPop").default;
PopComponent["PeakList"] = require("./Course/PopContent/PeakList").default;
PopComponent["CopyCoursePop"] =
  require("./Course/PopContent/CopyCoursePop").default;
PopComponent["CopyEventPop"] =
  require("./Course/PopContent/CopyEventPop").default;
PopComponent["EventPeakList"] = require("./Events/PopContent/PeakList").default;
PopComponent["EventPeakList"] =
  require("./FreeClasses/PopComponent/PeakList").default;
PopComponent["EventSearchPop"] =
  require("./Events/PopContent/SearchPop").default;
PopComponent["EventSearchPop"] =
  require("./FreeClasses/PopComponent/SearchPop").default;
PopComponent["GroupPeakList"] = require("./Groups/PopContent/PeakList").default;
PopComponent["DeleteAlert"] = require("./Course/PopContent/AlertPop").default;
PopComponent["ApplicationDeleteAlert"] = require("./Applications/PopContent/AlertPop").default;
PopComponent["EventDeleteAlert"] =
  require("./Events/PopContent/AlertPop").default;
PopComponent["UserAlert"] = require("./Users/PopUp/AlertPop").default;
PopComponent["UserEnrolledPop"] =
  require("./Users/PopUp/UserEnrolledPop").default;
PopComponent["DeletePop"] = require("../component/DeletePop").default;
PopComponent["AddThoughtLeader"] =
  require("./ThoughtLeaders/PopContent/AddThoughtLeader").default;
PopComponent["EditThoughtLeader"] =
  require("./ThoughtLeaders/PopContent/EditThoughtLeader").default;
PopComponent["SearchThoughtLeader"] =
  require("./ThoughtLeaders/PopContent/SearchPop").default;
PopComponent["SkillsPop"] =
  require("./ThoughtLeaders/PopContent/SkillsPop").default;
PopComponent["LeaderPeakList"] =
  require("./ThoughtLeaders/PopContent/PeakList").default;
PopComponent["GroupUserPop"] = require("./Groups/PopContent/UserPop").default;
PopComponent["GroupSkillsPop"] =
  require("./Groups/PopContent/SkillsPop").default;
PopComponent["EventSkillsPop"] =
  require("./Events/PopContent/SkillsPop").default;
PopComponent["EventSkillsPop"] =
  require("./FreeClasses/PopComponent/SkillsPop").default;
PopComponent["ErrorPop"] = require("../PopContent/ErrorPop").default;
PopComponent["EditGroupPop"] =
  require("./Groups/PopContent/EditGroupPop").default;
PopComponent["SearchGroup"] = require("./Groups/PopContent/SearchPop").default;
PopComponent["AddGroup"] = require("./Groups/PopContent/AddGroup").default;
PopComponent["DeleteAlertPop"] =
  require("./Groups/PopContent/AlertPop").default;
PopComponent["SearchDiscourseActivity"] =
  require("./ActionLogs/PopContent/SearchPop").default;
PopComponent["ConversionPop"] =
  require("./Groups/PopContent/ConversionPop").default;
PopComponent["certificatePop"] = require("./Users/PopUp/AddCertificatePop").default;
PopComponent["Extend_course_date"] = require("./Users/PopUp/Extend_course_date").default;
PopComponent["ResetpasswordPop"] = require("./../pages/ResetpasswordPopup").default;
PopComponent["MarkUserAsPaidPop"] = require("./Users/PopUp/MarkUserAsPaidPop").default;

export default PopComponent;

